export class TextProvider {
    public static expectedDeliveryDate = {
        deliveryTo: 'Levering til',
        delivery: 'Leveranse',
        deliveryToInfo: 'Skriv inn postnummeret ditt for å sjekke leveringsmetoder.',
        change: 'Endre',
        estimatedDelivery: 'Antatt leveringsdato',
        today: 'i dag',
        tomorrow: 'i morgen',
        cooledProductDelivery: 'Kjølevare',
        cooledProductDeliveryTo: 'Kjølevarelevering til postnummer',
        cooledProductDeliveryInfo: 'Denne varen kan kun leveres med Gordon kjøletransport. Levering er foreløpig tilgjengelig på Østlandet.',
        moreAboutCooledDelivery: 'Les mer',
        checkDelivery: 'Sjekk postnummer',
        noDelivery: 'Vi kan dessverre ikke levere til deg ennå',
        noDeliveryInfo: 'Denne varen kan kun leveres med Gordon kjøletransport. Levering er foreløpig tilgjengelig på Østlandet.'
    };
}
